import { InvestTypes } from '../types/invest'
import { getErrorHelper } from 'src/utils/response-helpers'
import investServices from 'src/services/invest'
import { action as typeSafeAction } from 'typesafe-actions'

export const getAllInvestmentAction = () => {
  return async (dispatch: any) => {
    try {
      const response: any = await investServices.getAllInvestments()
      dispatch(
        typeSafeAction(
          InvestTypes.GET_ALL_INVESTMENTS_SUCCESS,
          response.data.data
        )
      )
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const getUserInvestmentAction = () => {
  return async (dispatch: any) => {
    dispatch(typeSafeAction(InvestTypes.GET_USER_INVESTMENTS_LOADING))
    try {
      const response: any = await investServices.getUserInvestments()
      dispatch(
        typeSafeAction(
          InvestTypes.GET_USER_INVESTMENTS_SUCCESS,
          response.data.data
        )
      )
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const createInvestmentAction = ({
  payload,
  onSuccess,
  onError,
}: any) => {
  return async (dispatch: any) => {
    // dispatch(typeSafeAction(InvestTypes.CREATE_INVESTMENT_LOADING))

    try {
      const response: any = await investServices.createInvestment(payload)

      if (response.data.data.successful) {
        // console.log(response.data.data.payment)
        onSuccess?.(response.data.data.server_response)
        dispatch(
          typeSafeAction(
            InvestTypes.CREATE_INVESTMENT_SUCCESS,
            response.data.data.payment
          )
        )
      } else {
        onError?.(response.data.data.server_response)
      }
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
